import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import References from "../../components/References";
import Tabs135 from "../../components/TabGroups/135Tabs";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_1_3 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */
  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main>
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.3.5 Kinetics of Amyvid Brain Uptake and Washout
            </h1>
            <p className="mt-1 mb-0">Estimated time to complete: 5 minutes</p>
          </section>
          <section className="mb-5 row">
            <div className="col-sm-12 col-md-8">
              <Tabs135 />
            </div>
            <div className="col-sm-12 col-md-4">
              <ul>
                <li>It is important to avoid beginning a scan too early</li>
                <li>
                  Amyvid uptake increases from 0 to 30 minutes after
                  administration and remains relatively constant between 45-90
                  minutes<sup>1-5</sup>
                </li>
                <li>
                  Note the poor quality of the scan taken in either patient when
                  the scan is taken less than 30 minutes after Amyvid
                  administration
                </li>
              </ul>
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-4", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-3-6", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>Data on file, Lilly Research Laboratories: AMY20120425G.</li>
              <li>Data on file, Lilly Research Laboratories: AMY20120425H.</li>
              <li>Data on file, Lilly Research Laboratories: AMY20121001S.</li>
              <li>Data on file, Lilly Research Laboratories: AMY20120425J.</li>
              <li>
                Wong DF, et al. <em>J Nucl Med.</em> 2010;51(6):913-920.
              </li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_1_3;
